import { useState, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { GiSquirrel } from "react-icons/gi";
// import DemoImg from '../../assets/Harsh_Photo.jpeg';
import React from "react";
interface GoogleCalendarPopupProps {
  isCalendarOpen: boolean;
  setIsCalendarOpen: (open: boolean) => void;
}
export default function GoogleCalendarPopup({
  isCalendarOpen,
  setIsCalendarOpen,
}: GoogleCalendarPopupProps) {
  const embedUrl = process.env.REACT_APP_GOOGLE_CALENDAR_EMBED_URL;
  console.log("Embed URL:", embedUrl);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const openCalendar = () => {
    console.log("Opening calendar...");
    setIsCalendarOpen(true);
    console.log("Calendar open state:", isCalendarOpen);
    // setIsDrawerOpen(false);
  };
  useEffect(() => {
    if (isCalendarOpen) {
      setLoading(true);
    }
  }, [isCalendarOpen]);
  //   const handleOpen = () => {
  //     setOpen(true)
  //     setLoading(true)            // start loader as soon as modal opens
  //   }

  const handleClose = () => {
    setOpen(false);
    setLoading(false); // reset loader
  };

  // Function to handle both open actions
  const handleButtonClick = () => {
    // handleOpen();
    openCalendar();
  };

  return (
    <>
      <button
        onClick={handleButtonClick}
        className=" w-[200px] px-4 py-4 bg-[#06526D] text-white rounded-lg hover:bg-[#054d68] transition"
      >
        <p className="font-bold text-[14px]">Book a 15-min ROI Demo</p>
      </button>

      {open && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 bg-transparent backdrop-filter"
          style={{ backdropFilter: "brightness(60%) contrast(80%)" }}
        >
          <div className="relative w-[95vw] max-w-2xl h-[80vh] sm:w-10/12 sm:max-w-4xl sm:h-4/5 bg-white rounded-lg overflow-hidden shadow-lg ">
            {/* Close button */}
            <button
              onClick={handleClose}
              className="absolute top-2 right-2   text-2xl z-50 p-1 mr-5 size-10"
            >
              {/* <IoCloseCircle /> */}
              <IoIosCloseCircleOutline className="mx-auto my-auto size-8" />
            </button>

            {/* Loader overlay */}
            {loading && (
              <div className="absolute inset-0 bg-white bg-opacity-90 z-40 flex flex-col items-center justify-center text-center rounded-lg">
                <img
                  src="https://d2qb2qddg7l6c6.cloudfront.net/legitt-website-v5/assets/images/Harsh_Photo.jpeg"
                  alt="Loading..."
                  className="w-32 h-32 sm:w-40 sm:h-40 mb-4 object-contain mx-auto rounded-full shadow-lg"
                />
                <p className="text-base sm:text-lg font-semibold text-[#06526D] flex flex-col sm:flex-row items-center justify-center px-2 text-center">
                  Please wait... We're opening the scheduling form for you
                  <span className="inline-block">
                    <span className="loading-dots ml-1" aria-label="loading">
                      <span>.</span>
                      <span>.</span>
                      <span>.</span>
                    </span>
                  </span>
                  <span
                    className="inline-block text-4xl sm:text-5xl animate-squirrel-move mt-2 sm:mt-0 sm:ml-3"
                    role="img"
                    aria-label="squirrel"
                  >
                    <GiSquirrel />
                  </span>
                </p>
                <style>
                  {`
            @keyframes squirrel-move {
              0% {
                transform: translateX(0) scaleX(1);
              }
              49.999% {
                transform: translateX(80px) scaleX(1);
              }
              50% {
                transform: translateX(80px) scaleX(-1) rotate(360deg);
              }
              100% {
                transform: translateX(0) scaleX(-1) rotate(360deg);
              }
            }
            .animate-squirrel-move {
              animation: squirrel-move 2s infinite linear;
            }
            @keyframes blink {
              0%, 80%, 100% { opacity: 0; }
              40% { opacity: 1; }
            }
            .loading-dots span {
              animation: blink 1.4s infinite both;
              font-size: 1.5em;
              line-height: 0;
            }
            .loading-dots span:nth-child(2) {
              animation-delay: 0.2s;
            }
            .loading-dots span:nth-child(3) {
              animation-delay: 0.4s;
            }
            `}
                </style>
              </div>
            )}

            {/* Iframe */}
            <iframe
              src={embedUrl}
              className="w-full h-full border-0"
              title="Booking Calendar"
              onLoad={() => setLoading(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
